import Vue from 'vue';
import Api, { ContentType } from '../network/Api';
import Storage from '../storage/Storage';
import Store from '../store/Store';
import Log from '../logger/Log';
import { $l } from '../locale';
import Axios from 'axios';
const TAG = 'package/Idg';
const routeNames = [];
let sID = 0;
function getSid() {
    sID = sID + 1;
    return sID;
}
class Idg {
    constructor(appid, channelOptions, packages, children) {
        this.packageInstances = [];
        this.appid = appid;
        this.channelOptions = channelOptions;
        this.packages = packages;
        this.children = children;
        this.storage = new Storage(this);
        this.routes = [];
        this.components = {};
        this.pages = {};
        this.apis = {};
        this.stores = {};
        this.options = {};
        this.controllers = {};
        this.sid = getSid();
    }
    // tslint:disable-next-line:no-empty
    init() { }
    getChannelOptions() {
        if (this.channelOptions &&
            typeof this.channelOptions.getChannelOptions === 'function') {
            return this.channelOptions.getChannelOptions(this);
        }
        return this.channelOptions;
    }
    register() {
        if (this.packages) {
            Log.debug(TAG, 'register', this.appid, this);
            this.packages.forEach((pkg) => {
                Log.debug(TAG, 'register pkg', pkg.name, pkg);
                this.registerOptions(pkg);
                const $store = this.registerStores(pkg);
                this.registerApis(pkg);
                this.registerControllers(pkg);
                this.registerComponents(pkg);
                this.registerPages(pkg);
                this.registerLocales(pkg);
                this.registerRoutes(pkg);
                const packageInstance = {
                    idg: this,
                    $l(key) {
                        return $l(this, key);
                    },
                    $store,
                    package: pkg,
                };
                // pkg注册路由before钩子
                if (pkg.routerBeforeEach) {
                    const routerBeforeEach = pkg.routerBeforeEach;
                    this.root.router.beforeEach((to, from, next) => {
                        routerBeforeEach(packageInstance, to, from, next);
                    });
                }
                // pkg注册路由after钩子
                if (pkg.routerAfterEach) {
                    const routerAfterEach = pkg.routerAfterEach;
                    this.root.router.afterEach((to, from) => {
                        routerAfterEach(packageInstance, to, from);
                    });
                }
                // pkg注册成功的钩子
                if (pkg.registered) {
                    pkg.registered(packageInstance);
                    this.packageInstances.push(packageInstance);
                }
            });
        }
        if (this.children) {
            this.children.forEach((child) => {
                child.register();
            });
        }
    }
    inject() {
        if (this.children) {
            this.children.forEach((child) => {
                child.inject();
            });
        }
        this.injectControllers();
        this.injectComponents();
        this.injectPages();
    }
    injectRoutes() {
        this.addRoutes();
        if (this.children) {
            this.children.forEach((child) => {
                child.injectRoutes();
            });
        }
    }
    setParent(parentPacakge) {
        this.parent = parentPacakge;
    }
    setRoot(appPackage) {
        this.root = appPackage;
    }
    /**
     * 调用下层api
     * @param requestConfig 请求配置
     */
    callService(requestConfig) {
        const httpOptions = Api.generateOptions(this);
        if (httpOptions.baseURL) {
            requestConfig.baseURL = httpOptions.baseURL;
        }
        if (!requestConfig.params) {
            requestConfig.params = {};
        }
        const headers = {
            RequestStack: JSON.stringify([].concat(this.getRequestStack(), requestConfig.requestStack)),
        };
        const token = this.root.getToken();
        if (token) {
            headers.Authorization = token;
        }
        requestConfig.headers = headers;
        requestConfig.headers['Content-Type'] = requestConfig.headers['Content-Type'] || ContentType.FORM_URLENCODED;
        requestConfig.data = Api.generateData(requestConfig.data, requestConfig.headers['Content-Type']);
        return Axios.request(requestConfig);
    }
    /**
     * Finds package instance 找到包实例
     * @param pkgName
     * @returns package instance
     */
    findPackageInstance(pkgName) {
        return this.packageInstances.find((pkg) => pkg.package.name === pkgName);
    }
    /**
     * 通过appid找到子服务
     * @param appid 产物标记
     */
    findChildByAppid(appid) {
        if (!this.children) {
            return undefined;
        }
        const childs = this.children.filter((child) => child.appid === appid);
        if (childs.length === 0) {
            return undefined;
        }
        return childs[0];
    }
    /**
     * Finds child by channel option 通过数据通道查找
     * @param channelOption 数据通道
     * @returns child by channel option Idg
     */
    findChildByChannelOption(appid, channelOption) {
        if (!this.children) {
            return undefined;
        }
        const childs = this.children.filter((child) => child.appid === appid && JSON.stringify(child.channelOptions) === JSON.stringify(channelOption));
        if (childs.length === 0) {
            return undefined;
        }
        return childs[0];
    }
    /**
     * Adds child 动态添加一个子
     * @param idg Idg
     * @returns child Idg
     */
    addChild(idg) {
        const child = this.findChildByChannelOption(idg.appid, idg.channelOptions);
        if (child) {
            return child;
        }
        if (!this.children) {
            this.children = [];
        }
        this.children.push(idg);
        this.init();
        this.register();
        this.inject();
        this.injectRoutes();
        return idg;
    }
    /**
     * 通过页面标记获取页面
     * @param pageId 完整页面标记，'[appid].[package].pageName'
     */
    getPage(pageId) {
        return this.getById(pageId, 'pages');
    }
    /**
     * 通过组件标记获取组件
     * @param componentId 完整component标记，'[appid].[package].componentName'
     */
    getComponent(componentId) {
        return this.getById(componentId, 'components');
    }
    /**
     * 通过api标记获取Api
     * @param apiId 完整的api标记
     */
    getApi(apiId) {
        return this.getById(apiId, 'apis');
    }
    /**
     * 获取调用栈
     */
    getRequestStack() {
        const requestStack = [];
        let parent = this;
        while (parent) {
            const channelOptions = parent.getChannelOptions();
            if (!channelOptions) {
                Log.warn(TAG, 'getRequestStack no channelOptions', channelOptions, parent);
                continue;
            }
            if (channelOptions.channelAlias) {
                requestStack.unshift({
                    appid: parent.appid,
                    channelAlias: parent.getChannelOptions().channelAlias,
                });
            }
            else {
                requestStack.unshift({
                    appid: parent.appid,
                    appkey: parent.getChannelOptions().appkey,
                    channel: parent.getChannelOptions().channel,
                });
            }
            parent = parent.parent;
        }
        return requestStack;
    }
    /**
     * 根据索引查找api或者组件
     * @param id 查找的索引
     * @param key apis || components
     */
    getById(id, key) {
        const ids = id.split('.');
        const appid = ids[0];
        Log.debug(TAG, 'getById', id, key, this);
        const child = this.findChildByAppid(appid);
        if (ids.length > 3) {
            const finded = appid === (this.parent && this.parent.appid) ? this.parent : child;
            if (!finded || !finded[key]) {
                return undefined;
            }
            ids.shift();
            Log.debug(TAG, 'getById finded', finded);
            return finded.getById(ids.join('.'), key);
        }
        // 服务内部
        if (appid === this.appid) {
            if (!this[key]) {
                return undefined;
            }
            Log.debug(TAG, 'getById0', this[key][id]);
            return this[key][id];
        }
        // 父级服务
        if (this.parent && appid === this.parent.appid) {
            if (!this.parent || !this.parent[key]) {
                return undefined;
            }
            Log.debug(TAG, 'getById1', this.parent);
            return this.parent[key][id];
        }
        // 子服务
        if (!child || !child[key]) {
            return undefined;
        }
        Log.debug(TAG, 'getById2', child);
        return child[key][id];
    }
    /**
     * 生成索引id【appid.packageName.name】
     * @param id name | packageName.name | appid.packageName.name
     * @param package 所属包
     * @param idg 所属服务
     */
    generateId(id, pkg, idg) {
        const ids = id.split('.');
        if (ids.length === 1) {
            ids.unshift(pkg.name);
        }
        if (ids.length === 2) {
            ids.unshift(idg.appid);
        }
        return ids.join('.');
    }
    /**
     * 筛选依赖
     * @param depends 依赖字符串数组 ['component.xx.xx', 'api.xxx']
     * @param key component|api|controller
     */
    filterDepends(depends, key) {
        return depends.filter((depend) => {
            let id = '';
            if (typeof depend === 'string') {
                id = depend;
            }
            else {
                id = depend.id;
            }
            return id.startsWith(key + '.');
        }).map((depend) => {
            let id = '';
            let variableName = '';
            if (typeof depend === 'string') {
                id = depend;
                variableName = this.getDefaultVariableName(id, key);
            }
            else {
                id = depend.id;
                variableName = depend.variableName;
            }
            return {
                id: id.slice(key.length + 1),
                variableName,
            };
        });
    }
    addRoutes() {
        const routes = this.addRoute(this.routes);
        this.root.router.addRoutes(routes);
    }
    /**
     * 注入多个路由
     * @param routes 路由数组
     */
    addRoute(routes) {
        return routes.filter((route) => {
            // 重复的路由筛选掉
            return !routeNames.includes(route.name);
        }).map((route) => {
            const pkg = route.package;
            routeNames.push(route.name);
            const routeConfig = {
                path: route.path,
                name: route.name,
                redirect: route.redirect,
                meta: route.meta,
            };
            if (route.page) {
                const pageId = this.generateId(route.page, pkg, this);
                const page = this.getPage(pageId);
                const self = this;
                if (!page) {
                    Log.warn('Idg injectRoute', `page ${pageId} not registered while ${route.name} injectRoute`, self);
                }
                else {
                    routeConfig.component = page;
                    Log.debug('Idg injectRoute', `${route.name} injectRoute page ${pageId}`);
                }
            }
            if (route.children) {
                routeConfig.children = this.addRoute(route.children);
            }
            return routeConfig;
        });
    }
    /**
     * 遍历controllers注入依赖
     */
    injectControllers() {
        Object.keys(this.controllers).forEach((controller) => {
            this.injectController(this.controllers[controller]);
        });
    }
    /**
     * 注入单个controller的依赖
     */
    injectController(controller) {
        this.injectcControllerApi(controller);
    }
    /**
     * 遍历组件注入依赖
     */
    injectComponents() {
        Object.keys(this.components).forEach((component) => {
            this.injectcComponentApi(this.components[component]);
        });
        Object.keys(this.components).forEach((component) => {
            this.injectcComponentController(this.components[component]);
        });
        Object.keys(this.components).forEach((component) => {
            this.injectComponent(this.components[component]);
        });
    }
    /**
     * 遍历页面注入依赖
     */
    injectPages() {
        Object.keys(this.pages).forEach((page) => {
            this.injectPage(this.pages[page]);
        });
    }
    /**
     * 注入组件的控制器依赖
     * @param Ctor 组件构造
     */
    injectcComponentController(Ctor) {
        if (!Ctor.options || !Ctor.options.depends) {
            return;
        }
        const depends = this.filterDepends(Ctor.options.depends, 'controller');
        this.injectcController(Ctor, depends);
    }
    // 注入Controller依赖
    injectcController(Ctor, depends) {
        this.injectDepends(Ctor, depends, 'controllers');
    }
    /**
     * 注入组件的API依赖
     * @param Ctor 组件构造
     */
    injectcComponentApi(Ctor) {
        if (!Ctor.options || !Ctor.options.depends) {
            return;
        }
        const depends = this.filterDepends(Ctor.options.depends, 'api');
        this.injectApi(Ctor, depends);
    }
    /**
     * 注入控制器的API依赖
     * @param Ctor 控制构造
     */
    injectcControllerApi(Ctor) {
        if (!Ctor.depends) {
            return;
        }
        const depends = this.filterDepends(Ctor.depends, 'api');
        this.injectApi(Ctor, depends);
    }
    // 注入Api依赖
    injectApi(Ctor, depends) {
        this.injectDepends(Ctor, depends, 'apis');
    }
    injectDepends(Ctor, depends, key) {
        const pkg = Ctor.prototype.$package;
        const dependCtors = {};
        const self = this;
        if (!pkg) {
            Log.warn(TAG, 'injectDepends: pkg not found', Ctor.ctorName, Ctor, depends, key, self);
            return;
        }
        depends.forEach((depend) => {
            const id = this.generateId(depend.id, pkg, this);
            const instanceName = depend.variableName;
            const registerCtor = this.getById(id, key);
            if (!registerCtor) {
                Log.debug(TAG, 'current idg', self);
                this.getById(id, key);
                throw new Error(`${id} not registered, please register first`);
            }
            dependCtors[instanceName] = new registerCtor();
        });
        Object.keys(dependCtors).forEach((instanceName) => {
            Ctor.prototype[instanceName] = dependCtors[instanceName];
            if (!this.injects) {
                this.injects = [];
            }
            const depend = dependCtors[instanceName];
            this.injects.push({
                key: instanceName,
                value: depend && depend.sid ? depend.sid : instanceName,
            });
            Log.debug('Idg', `${Ctor.ctorName} injectDepend ${instanceName}`);
        });
    }
    /**
     * 注入单个组件的依赖
     * @param Ctor 组件构造函数
     */
    injectComponent(Ctor) {
        return this.injectComponentOrPage(Ctor, 'components');
    }
    /**
     * 注入单个页面的依赖
     * @param Ctor 组件构造函数
     */
    injectPage(Ctor) {
        return this.injectComponentOrPage(Ctor, 'pages');
    }
    /**
     * 注入单个页面或组件的依赖
     * @param Ctor 组件构造函数
     */
    injectComponentOrPage(Ctor, key) {
        if (Ctor.injected === true || !Ctor.options || !Ctor.options.depends) {
            return Ctor;
        }
        const depends = this.filterDepends(Ctor.options.depends, 'component');
        const dependComponents = {};
        const pkg = Ctor.package;
        const self = this;
        depends.forEach((depend) => {
            const dependStrs = depend.id.split('.');
            const dependName = dependStrs[dependStrs.length - 1];
            const dependId = this.generateId(depend.id, pkg, this);
            const dependComponent = this.getComponent(dependId);
            if (dependComponent) {
                dependComponents[depend.variableName] = this.injectComponent(dependComponent);
                Log.debug('Idg', `injectComponent ${dependName}`, depends);
            }
            else {
                Log.warn('Idg', 'injectComponent depend component not found', dependId, self);
            }
        });
        const options = {
            components: dependComponents,
        };
        const extendCtor = Ctor.extend(options);
        extendCtor.injected = true;
        if (!Ctor.ctorName) {
            Log.debug(TAG, 'current idg', this);
            throw new Error('no ctorName found in Ctor');
        }
        const componentId = this.generateId(Ctor.ctorName, Ctor.package, this);
        this[key][componentId] = extendCtor;
        return extendCtor;
    }
    /**
     * 根据id获取默认变量名
     * @param id id【xx.xx.xx】
     */
    getDefaultVariableName(id, key) {
        const ids = id.split('.');
        const dependName = ids.length > 1 ? ids[ids.length - 1] : id;
        if (key === 'component') {
            return dependName;
        }
        const characters = dependName.split('');
        if (characters.length > 0) {
            characters[0] = characters[0].toLowerCase();
        }
        return characters.join('');
    }
    /**
     * 注册api
     * @param pkg 所属包
     */
    registerApis(pkg) {
        if (!pkg.apis) {
            return;
        }
        const apis = pkg.apis;
        Object.keys(apis).forEach((apiName) => {
            const apiId = this.generateId(apiName, pkg, this);
            this.apis[apiId] = this.decorateApi(apiName, apis[apiName]);
        });
    }
    /**
     * 注册controllers
     * @param pkg 所属包
     */
    registerControllers(pkg) {
        if (!pkg.controllers) {
            return;
        }
        const controllers = pkg.controllers;
        Object.keys(controllers).forEach((controlerName) => {
            const controlerId = this.generateId(controlerName, pkg, this);
            this.controllers[controlerId] = this.decorateController(controlerName, controllers[controlerName], pkg);
        });
    }
    /**
     * 装饰Api
     * @param Ctor Api构造函数
     */
    decorateApi(apiName, Ctor) {
        // tslint:disable-next-line:max-classes-per-file
        class IdgApi extends Ctor {
        }
        IdgApi.prototype.sid = getSid();
        IdgApi.prototype.idg = this;
        return IdgApi;
    }
    /**
     * 装饰Controller
     * @param Ctor Controller构造函数
     */
    decorateController(ctorName, Ctor, pkg) {
        // tslint:disable-next-line:max-classes-per-file
        class IdgController extends Ctor {
        }
        IdgController.prototype.idg = this;
        IdgController.prototype.sid = getSid();
        IdgController.prototype.decorated = true;
        IdgController.prototype.ctorName = ctorName;
        IdgController.prototype.$package = pkg;
        IdgController.prototype.store = this.stores[this.generateId('store', pkg, this)];
        return IdgController;
    }
    /**
     * 注册包中所有的组件
     * @param pkg 包
     */
    registerComponents(pkg) {
        Log.debug(TAG, 'registerComponents', pkg);
        this.registerComponentsOrPages(pkg, 'components');
    }
    /**
     * 注册包中所有的页面
     * @param pkg 包
     */
    registerPages(pkg) {
        Log.debug(TAG, 'registerPages', pkg);
        this.registerComponentsOrPages(pkg, 'pages');
    }
    /**
     * 注册包中所有的页面或者组件
     * @param pkg 包
     * @param key components | pages
     */
    registerComponentsOrPages(pkg, key) {
        if (!pkg[key]) {
            return;
        }
        const components = pkg[key];
        Object.keys(components).forEach((componentName) => {
            const decoratedName = this.generateId(componentName, pkg, this);
            const component = components[componentName];
            const decoratedComponent = this.decorateComponent(componentName, component, pkg, key);
            this[key][decoratedName] = decoratedComponent;
        });
    }
    /**
     * 装饰组件
     * @param componentName 组件名称
     * @param component 组件构造函数
     * @param pkg 组件所属包
     */
    decorateComponent(componentName, component, pkg, key) {
        Log.debug(TAG, 'decorateComponent', componentName, key, pkg);
        const originCtor = component;
        if (originCtor.decorated) {
            return originCtor;
        }
        let Ctor = Vue.extend(originCtor);
        const storeOptions = this.stores[this.generateId('store', pkg, this)];
        if (storeOptions) {
            Ctor = Ctor.extend({ store: storeOptions });
        }
        const options = this.options[this.generateId('options', pkg, this)];
        if (options) {
            Ctor = Ctor.extend(options);
        }
        const extendedCtor = this.extendComponet(Ctor);
        extendedCtor.prototype.$app = this.root;
        extendedCtor.prototype.$idg = this;
        extendedCtor.prototype.$package = pkg;
        extendedCtor.prototype.getComponent = function (componentId) {
            const dependStrs = componentId.split('.');
            if (dependStrs.length > 3) {
                this.logger.warn('Idg decorateComponent', 'invalid depend component', componentId);
                return null;
            }
            const { $idg, $package } = this;
            if (dependStrs.length === 1) {
                dependStrs.unshift($package.name);
            }
            if (dependStrs.length === 2) {
                dependStrs.unshift($idg.appid);
            }
            return $idg.getComponent(dependStrs.join('.'));
        };
        // components => component | pages => page
        extendedCtor.prototype.$componentType = key.slice(0, key.length - 1);
        extendedCtor.decorated = true;
        extendedCtor.idg = this;
        extendedCtor.package = pkg;
        extendedCtor.ctorName = componentName;
        return extendedCtor;
    }
    extendComponet(Ctor) {
        // tslint:disable-next-line:max-classes-per-file
        return class IdgVueComponent extends Ctor {
        };
    }
    /**
     * 注册包中的多语言
     * @param pkg 包
     */
    registerLocales(pkg) {
        if (!pkg.locales) {
            return;
        }
        const locales = pkg.locales;
        Object.keys(locales).forEach((locale) => {
            this.root.i18n.mergeLocaleMessage(locale, {
                [this.appid]: {
                    [pkg.name]: locales[locale],
                },
            });
        });
    }
    /**
     * 注册状态管理
     * @param pkg 所属包
     */
    registerStores(pkg) {
        const storeOptions = pkg.store || {};
        const storeId = this.generateId('store', pkg, this);
        const storeIns = new Store(storeOptions, pkg, this);
        this.stores[storeId] = storeIns;
        return storeIns;
    }
    /**
     * 注册组件options
     * @param pkg 所属包
     */
    registerOptions(pkg) {
        if (!pkg.options) {
            return;
        }
        const optionId = this.generateId('options', pkg, this);
        this.options[optionId] = pkg.options;
    }
    /**
     * 注册路由
     * @param pkg 所属包
     */
    registerRoutes(pkg) {
        if (!pkg.routes) {
            return;
        }
        this._registerRoutes(pkg.routes, pkg).forEach((route) => {
            this.routes.push(route);
        });
    }
    _registerRoutes(routes, pkg) {
        return routes.map((route) => {
            route.package = pkg;
            if (route.children) {
                route.children = this._registerRoutes(route.children, pkg);
            }
            return route;
        });
    }
}
export default Idg;
